//setup window helpers
  window._s1 = window._s1 || {};

 window.triggerLECPopup = () => {
    
    let id = 'SAr9cz'
    if(window.location.href.includes('uk.stepone.life')){
      id = ""
    } else if (window.location.href.includes('us.stepone.life')) {
      id = ""
    }
  
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  }

 window.setQuickBuyDrawerQuantity = (ele,qty) => {
    const newPriceStr = `${ele.dataset.price} ea.`;
    const openDrawer = [...$('.quick-buy-drawer')].filter(e => $(e).is(':visible'))[0];
    const $activeButton = $(openDrawer).find('.block-swatch');
    const $price = $(openDrawer).find('.drawer-price');
    const $newPrice = $(openDrawer).find('.new-price');
    const $compareAtPrice = $(openDrawer).find('.compare-at-price');
    
    $activeButton.css('border', '');
    
    // Hide the regular price when showing pack discount
    $price.css('display', 'none');
    
    // Show compare-at price struck through if it exists
    if($compareAtPrice.length) {
      $compareAtPrice
        .css('text-decoration', 'line-through')
        .css('color', '#767676') /* a11y 13/10/2026: #999 is 2.84:1 */
        .show();
    }
    
    // Show the pack discounted price in red
    $newPrice.text(newPriceStr).css('display', 'block').css('color', '#d10000') /* a11y 13/10/2026: pure red is 3.99:1 */;
    
    ele.style.border='2px solid black';
    $(openDrawer)
      .find('.quantity-selector input')
      .val(qty)
      .trigger("input");
  }

  _s1.getTieredPricing = () => {
    const tiers = {
      au: {
        currency: '$',
        low_tier: {
          threshold: 4,
          dollars_off: 2,
          discount_total: 8
        },
        mid_tier: {
          threshold: 7,
          dollars_off: 4,
          discount_total: 28
        },
        high_tier: {
          threshold: 15,
          dollars_off: 10,
          discount_total: 150
        },
      },
      uk: {
        currency: '£',
        low_tier: {
          threshold: 4,
          dollars_off: 1,
          discount_total: 4
        },
        mid_tier: {
          threshold: 7,
          dollars_off: 3,
          discount_total: 21
        },
        high_tier: {
          threshold: 10,
          dollars_off: 5,
          discount_total: 50
        }
      },
      us: {
        currency: '$',
        low_tier: {
          threshold: 3,
          dollars_off: 2,
          discount_total: 6
        },
        mid_tier: {
          threshold: 5,
          dollars_off: 5,
          discount_total: 25
        },
        high_tier: {
          threshold: 10,
          dollars_off: 8,
          discount_total: 80
        }
      }
    }
    return tiers[_s1.getS1Region()];
  }

  window.handleGift = async (key) => {
    const region = _s1.getS1Region();
    const gift_variant_map = {
      us: {
        "100": 42409048539286,
        "150": 42409048572054,
        "200": 42409048604822
      },
      uk: {
        "20": 34581861531785,
        "50": 34581861564553,
        "100": 34581861597321
      }, 
      au: {
        "100": 39738961952840,
        "150": 39738961985608,
        "200": 39738962018376
      }
    }
    const $button = $(`button#gift-${key}`);
    
    if($button.length > 0){
      $button.attr('aria-busy', true);
    }
    
    const variant_id = gift_variant_map[region][key];
    await _s1.addToCartAndRefreshCart([{
        id: variant_id,
        quantity: 1
      }])

    if($button.length > 0){
      $button.attr('aria-busy', false);
    }
    
  }

  _s1.addToCartAndRefreshCart = async (items) => {
      const response = await _s1.addToCart(items);
      return await _s1.refreshCart(response);
  }

  _s1.getSetABExperiment = (experiment_key) => {
    const exp = Cookies.get(experiment_key);
    if(exp) return exp;
    const randomNumber = Math.random();
    const new_exp = randomNumber < 0.5 ? "A" : "B";
    Cookies.set(experiment_key,new_exp);
    return new_exp;
  }

 _s1.updateCartAndRefreshCart = async (updates) => {
    const response = await _s1.updateCart(updates);
    return await _s1.refreshCart(response);
  }

  _s1.updateCart = async (updates) => {
    const response = await fetch(`/cart/update.js?sections=${window.CartSectionID},variant-added`, {
      body: JSON.stringify({updates}),
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json"
      }
    });
    return await response.json();
  }

  _s1.addCartListener = (callback) => {
    (function(ns, fetch) {
      if (typeof fetch !== 'function') return;
    
      ns.fetch = function() {
          const response = fetch.apply(this, arguments);
    
          response.then(res => {
            const base_res_url = res.url.split('?')[0];
              if ([
                      `${window.location.origin}/cart/add.js`,
                      `${window.location.origin}/cart/update.js`,
                      `${window.location.origin}/cart/change.js`,
                      `${window.location.origin}/cart/clear.js`,
                  ].includes(base_res_url)) {
                  res.clone().json().then(data => callback(data));
              }
          });
    
          return response;
      }
    
    }(window, window.fetch))
  }

  _s1.getCurrentBaseURL = () => {
    const region = _s1.getS1Region();
    return _s1.getBaseURLFromRegion(region);
  }

  _s1.getBaseURLFromRegion = (region) => {
    if(region === 'uk') return 'https://europe-central2-stepone-backend-uk.cloudfunctions.net';
    if(region === 'us') return 'https://us-central1-stepone-backend-us.cloudfunctions.net';
    return 'https://australia-southeast1-stepone-backend.cloudfunctions.net'
  }

  _s1.getS1Region = () => {
    if(window.location.href.includes('uk.stepone')) return 'uk';
    if(window.location.href.includes('us.stepone')) return 'us';
    return 'au';
  }

  _s1.getCountryCode = async () => {
    const response = await fetch('/browsing_context_suggestions.json');
    const json = await response.json()
    return json.detected_values;
  }

  _s1.addToCart = async (items) => {

    const response = await fetch(`/cart/add.js?sections=${window.CartSectionID},variant-added`, {
        body: JSON.stringify({items}),
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json"
        }
      });
  
    return await response.json();
  
  }

_s1.artificalRemoveStock = () => {
    if(!window.location.href.includes('/products')) return;
    _s1.queue(function(){
        return jQuery && jQuery('label.block-swatch').length > 0 && jQuery('input.sr-only').length > 0
    }, function(){
        jQuery('label.block-swatch').addClass('is-disabled');
        jQuery('input.sr-only').click(function(e){
            e.preventDefault();
        })
    })
}

_s1.addDiscountToCart = async (discountCode, notify = false) => {
    await fetch(`/discount/${discountCode}`);
    if(notify){
      _s1.notify(`Your Discount "${discountCode}" Has Been Applied`);
    }
  }
  
  _s1.refreshCart = async (response) => {
  
  const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
  
  cartContent["sections"] = response.sections;
  
  document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
    bubbles: true,
    detail: {
      items: response.hasOwnProperty("items") ? response["items"] : [response],
      cart: cartContent
    }
  }));
  
  document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
    bubbles: true,
    detail: {
      baseEvent: "variant:add",
      cart: cartContent
    }
  }));
}

_s1.notify = (message, colour = '#28a745', delay = 2000) => {
  $('#notification-bar')
    .text(message)
    .css('background-color', colour)
    .slideDown(300)
    .delay(delay)
    .slideUp(300);
}

_s1.classOnMobile = (ele, className) => {
  // Create a media query list for screens with max-width 999px.
  const mediaQuery = window.matchMedia('(max-width: 999px)');

  // This function applies or removes the class based on the media query.
  const toggleClass = (e) => {
    if (e.matches) {
      // If mobile: add the class if it's not already there.
      ele.classList.add(className);
    } else {
      // Otherwise: remove the class.
      ele.classList.remove(className);
    }
  };

  // Run the function immediately to set the correct class on page load.
  toggleClass(mediaQuery);

  // Listen for changes in the media query.
  // Modern browsers support addEventListener; older ones might need addListener.
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', toggleClass);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(toggleClass);
  }
}

_s1.getCart = async () => {
    const res = await fetch('/cart.js');
    return await res.json();
}

_s1.swapImageSrcset = (img, newSrc) => {

    if (!img || !newSrc) return;
    
    img.src = newSrc;
    img.srcset = newSrc;
}

_s1.addAttributeToOrder = (key,value) => {
  return fetch('/cart', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              attributes: {
                  [key]: value
              }
          })
      });
}

_s1.getQueryParam = (key) => {
   const current_url = new URL(window.location.href);
   const param = current_url.searchParams.get(key);
  return param;
}

_s1.queue = function(){
  if(arguments.length == 0)
      return;
  var i = 0,
      maxlimit = 1000,
      limit = maxlimit,
      args = arguments;
  var x = setInterval(function(){
      var r = false;
      try{
          r = args[i]();
      } catch(e) {
          clearInterval(x);
          return;
      }
      
      if(r)
      {
          limit = maxlimit;
          i++;
          if(i >= args.length)
              clearInterval(x);
      }
  
      if(limit < 0) clearInterval(x);
      limit--;
  }, 50);
};

// custom logic for PDP
(() => {

  // KLAVIYO BIRTHDAY CUSTOM LOGIC
  window.addEventListener("klaviyoForms", function(e) { 

     if(e.detail.type != 'submit') return;
     if(e.detail.metaData.$source !== 'Birthday Sign Up Page') return;
     
     const {
        date_of_birth,
        customer_sex,
        preferred_print_type,
        preferred_size
     } = e.detail.metaData;
  
     const date_parts = date_of_birth.split('/');
     const month_day = `${date_parts[0]}/${date_parts[1]}`;
     const year = date_parts[2]
  
    _learnq.push(['identify', {
        date_of_birth,
        Birthday: `${month_day}/${new Date().getFullYear()}`,
        birthday_year: Number(year),
        customer_sex,
        preferred_print_type,
        preferred_size,
    }]);
  
   });

  // DISCOUNT APPLICATION CODE
  const current_url = new URL(window.location.href);
  const discountParam = current_url.searchParams.get('discount');
  if(discountParam){
    _s1.addDiscountToCart(discountParam, true);
  }

  $(document).ready(function(){

    const showGenderProductTab = () => {
      const hasProductTabs = $('.product_tabs').length > 0;
      const isProductPage = window.location.href.includes('/products');
      
      if(isProductPage) return;
      if(!hasProductTabs) return;

      let gender = 'mens';
      const campaignName = _s1.getQueryParam('utm_campaign');
      
      if(campaignName && campaignName.toLowerCase().includes('women')) gender = 'womens'
      if(campaignName && campaignName.toLowerCase().includes('kid')) gender = 'kids'
      
      if(campaignName && ( campaignName.toLowerCase().includes('women') || campaignName.toLowerCase().includes('kids') ) ){
        _s1.queue(function(){
          return $(`.product_catalog_tabs a[data-gender="${gender}"]`).length > 0
        }, function(){
          $(`.product_catalog_tabs a[data-gender="${gender}"]`)[0].click();
          return true
        })
      }
    }

    const addAttributeForRefferingFriend = () => {
      const queryRef = _s1.getQueryParam('mys24_ref_sender');
      const cookieRef = Cookies.get('mys24_ref_sender');
      const hasRef = queryRef || cookieRef;
      if(!hasRef) return;
      Cookies.set('mys24_ref_sender', hasRef);
      _s1.addAttributeToOrder('mys24_ref_sender', hasRef);
    }

    const getButtonFromSelectedSize = (size) => {
      const btn = document.querySelector(`input.sr-only[value="${size}"]`);
      if(btn) return btn;

      const fallbackMap = {
        "S" : "Small",
        "Small": "S",
        "M": "Medium",
        "Medium": "M",
        "Large": "L",
        "L": "Large"
      }

      const fallbackValue = fallbackMap[size];
      const fallbackBtn = document.querySelector(`input.sr-only[value="${fallbackValue}"]`);

      if(fallbackBtn) return fallbackBtn;
      return false;
    }

    const initFatherAndSon = () => {
      
      	function addNavSize(size, pageLocation = '#', prepend = false){
    		const template = `
    			<a href="${pageLocation}">
    				<input class="sr-only" type="radio" name="option2" value="${size.toUpperCase()}">
    				<label class="block-swatch is-size-${size.toLowerCase()}">
    		          <span>${size.toUpperCase()}</span>
    		     	</label>
    	     	</a>
    		`
    		if(prepend){
    			$($('.variant-picker__option-values')[3]).prepend(template)
    		} else {
    			$($('.variant-picker__option-values')[3]).append(template);
    		}
    	}
    
    	const isTrunk = window.location.href.includes('junior-trunk');
    	const isBoxerBrief = window.location.href.includes('boxer-brief');
    	const isSon = window.location.href.includes('son');
    
    	if(isTrunk && isSon){
    		const boxer_sizes = ['S', 'M'];
    		for(const size of boxer_sizes){
    			addNavSize(size, `/products/boxer-brief-son?size=${size}#product-tab-originals`)
    		}
    	}
    
    	if(isBoxerBrief && isSon){
    		const trunk_sizes = ['4XS', '3XS', '2XS', 'XS'].reverse();
    		for(const size of trunk_sizes){
    			addNavSize(size, `/products/junior-trunk-son?size=${size}#product-tab-originals`, true)
    		}
    	}

        const prefilled_size = _s1.getQueryParam('size');
        if(!prefilled_size) return;
        const sizeBtn = getButtonFromSelectedSize(prefilled_size);
        let hasRun = false;
         document.addEventListener('disabled-variants-updated', function(){
           if(hasRun) return;
           sizeBtn.click();
           hasRun = true;
         })
    }


    const initScrollFromBanner = () => {
      const $banner = $('.content-over-media');
      const $tabs = $('.product_tabs');
      if($banner.length == 0 || $tabs.length == 0) return;
      $banner.click(function() {
          $('html, body').animate({
              scrollTop: $tabs.offset().top - 100
          }, 10);
      });
    }

    const initProductCardsSwatches = () => {
      const $swatches = $('.product-card-swatch .color-swatch');
      if($swatches.length === 0) return;
      $swatches.click(function(e){
        e.preventDefault();
        
        const $parent = $(e.currentTarget).parent();
        const newSrc = $parent.data('imgSrc');
        
        const quickBuyId = $parent.data('quickBuyId');
        const quickBuyDraw = $(`#${quickBuyId}`);
        const productHandle = quickBuyDraw.attr('handle');
        
        const $productCard = $(e.currentTarget).parents('.multi-column__item');
        
        const img = $productCard.find('img')[0];
        const a = $productCard.find('a')[0];
        const addBtn = $productCard.find('#bfcm-quick-btn')[0];
        const shopAllBtn = $productCard.find('.product-card-button:not(#bfcm-quick-btn)')[0];

        shopAllBtn.setAttribute('href', `/products/${productHandle}`);
        a.setAttribute('href', `/products/${productHandle}`);
        addBtn.setAttribute('aria-controls', quickBuyId);
        _s1.swapImageSrcset(img, newSrc);
      })
    }

    const initSurfPages = async () => {
      if(!window.location.href.includes('/pages/slsa-clubs')) return;
      const club_name = _s1.getQueryParam('club');
      if(!club_name) window.location.href = '/pages/slsa-pick-your-club';
      _s1.addAttributeToOrder('slsa-selected-club',club_name).then(res => res.json()).then(console.log);
      $('.club-name').text(club_name);
      console.log('done');
    }

    const initSurfDonationBanner = async () => {
      if(!window.location.href.includes('/products/') || ! (window.location.href.includes('slsa') || window.location.href.includes('nippers') ) ) return;
      const cart = await _s1.getCart();
      const club = cart.attributes['slsa-selected-club'];
      if(!club) return;
      $(`<div class="banner" style="
          background-color: #ffd10c;
          color: #e10011;
          border-radius: 20px;
          font-weight: bold;
          justify-content: center;">
          Upon purchase $5 will go to: ${club}
        </div>`).insertBefore('.buttonwrap')
    }

    const club_name = _s1.getQueryParam('club');
    if(club_name){
      _s1.addAttributeToOrder('slsa-selected-club',club_name);
    }

    const initDiscountBarV3 = () => {
        let discountTiers;
      
        if(window.location.href.includes('uk.stepone')){
            discountTiers =  {
              tiers: [
                {"threshold": 4, "discount": 4},
                { "threshold": 7, "discount": 21},
                { "threshold": 10, "discount": 50}
              ],
              currency: '£'
            }
        } else if (window.location.href.includes('us.stepone')){
          discountTiers = {
            "tiers": [
              { "threshold": 3, "discount": 6},
              { "threshold": 5, "discount": 25},
              { "threshold": 10, "discount": 80}
            ],
            currency: '$'
          }
        } else {
          discountTiers = {
            "tiers": [
              { "threshold": 4, "discount": 8},
              { "threshold": 7, "discount": 28},
              { "threshold": 15, "discount": 150}
            ],
            currency: '$'
          }
        }
  
      function setTierTextColour(tier, progress){
        [...document.querySelectorAll(`.tier-text-${tier}`)]
          .forEach(tier => tier.style.color = progress >= 100 ? 'var(--yellow-color)' : 'white');
      }

      function setTierProgress(tier, progress){
        [...document.querySelectorAll(`#progress-fill-${tier}`)]
          .forEach(tier => tier.style.width = progress > 0 ? `${progress}%` : '0');
      }

      function updateTier(tier,progress){
        setTierProgress(tier,progress);
        setTierTextColour(tier,progress);
      }
  
      function updateDiscountBars(itemCount) {
  
        const tier1Progress = Math.min((itemCount / discountTiers.tiers[0].threshold) * 100, 100);
        const tier2Progress = Math.min(( (itemCount - discountTiers.tiers[0].threshold) / (discountTiers.tiers[1].threshold - discountTiers.tiers[0].threshold)) * 100, 100);
        const tier3Progress = Math.min(( (itemCount - discountTiers.tiers[1].threshold) / (discountTiers.tiers[2].threshold - discountTiers.tiers[1].threshold)) * 100, 100);

        updateTier('1', tier1Progress);
        updateTier('2', tier2Progress);
        updateTier('3', tier3Progress);
        
        // Update message
        let message = `Add ${discountTiers.tiers[0].threshold - itemCount} items to save ${discountTiers.currency}${discountTiers.tiers[0].discount} on your order!`;
        if (itemCount >= discountTiers.tiers[2].threshold) {
          message = `You're saving ${discountTiers.currency}${discountTiers.tiers[2].discount} on your order!`;
        } else if (itemCount >= discountTiers.tiers[1].threshold) {
          message = `Add <span class="stagared-chip">${discountTiers.tiers[2].threshold - itemCount}</span> more to save <span class="stagared-chip yellow">${discountTiers.currency}${discountTiers.tiers[2].discount}</span>`;
        } else if (itemCount >= discountTiers.tiers[0].threshold) {
          message = `Add <span class="stagared-chip">${discountTiers.tiers[1].threshold - itemCount}</span> more to save <span class="stagared-chip yellow">${discountTiers.currency}${discountTiers.tiers[1].discount}</span>`;
        } else if (itemCount > 0) {
          message = `Add <span class="stagared-chip">${discountTiers.tiers[0].threshold - itemCount}</span> more to save <span class="stagared-chip yellow">${discountTiers.currency}${discountTiers.tiers[0].discount}</span>`;
        }

        if(document.getElementById('discount-text')){
          document.getElementById('discount-text').innerHTML = message;
        }
        
      }

      function setupLabels(){
        $('.tier-text-1.pack').text(`${discountTiers.tiers[0].threshold} Pack`);
        $('.tier-text-2.pack').text(`${discountTiers.tiers[1].threshold} Pack`);
        $('.tier-text-3.pack').text(`${discountTiers.tiers[2].threshold} Pack`);
      }
  
      async function getEligableCartItemCount(){
        const cart = await _s1.getCart();
        let count = 0;
        for(const item of cart.items){
          if(item.title.toLowerCase().includes('police')) continue;
          if(item.title.toLowerCase().includes('gift')) continue;
          if(item.title.toLowerCase().includes('knit')) continue;
          count += item.quantity
        }
        return count;
      }
  
      async function updateFromCart() {
          const cartItemCount = await getEligableCartItemCount();
          updateDiscountBars(cartItemCount);
        }
  
      _s1.addCartListener(updateFromCart);
      updateFromCart();
      setupLabels();
    }

    window.window.initDiscountBar = initDiscountBarV3;

    const initProductCardSwatchesV2 = () => {
      const $swatches = $('.product-card-swatch > .color-swatch');
      if($swatches.length === 0) return;
      $swatches.click(function(e){
        e.preventDefault();
        
        const $parent = $(e.currentTarget).closest('.product-card-swatch');
        const newSrc = $parent.data('imgSrc');
        
        const quickBuyId = $parent.data('quickBuyId');
        const price = $parent.data('price');
        const quickBuyDraw = $(`#${quickBuyId}`);
        const productHandle = quickBuyDraw.attr('handle');
        
        const $productCard = $(e.currentTarget).closest('.catalog_product');
        
        const img = $productCard.find('img')[0];
        _s1.swapImageSrcset(img, newSrc);
        
        const a = $productCard.find('a')[0];
        a.setAttribute('href', `/products/${productHandle}`);
        
        const addBtn = $productCard.find('#catalog_product_cta_atc')[0];
        addBtn.setAttribute('aria-controls', quickBuyId);
        
        const shopAllBtn = $productCard.find('.catalog_product_cta a')[0];
        shopAllBtn.setAttribute('href', `/products/${productHandle}`);

        const $price = $productCard.find('.catalog_product_price');
        $price.text(price);
        
      })
    }

    const initProductCardSwitcher = () => {
      const $tabs_container = $('.product_catalog_tabs');
      if($tabs_container.length === 0) return;

      const $sections = [...$('.catalog_product_container')].map(e => $(e));

      const $getVisibleTab = () => {
        return $($sections.filter(e => !e.is(':hidden'))[0][0]);
      }

      const resetScrollAndButtons = () => {
        $sections.forEach($section => {
          $section.scrollLeft(0);
          $('.scroll-left').addClass('disabled');
          $('.scroll-right').removeClass('disabled');
        })
      }

      const possibleTabs = ['mens', 'womens', 'kids', 'boys', 'girls']
      const $tabs = possibleTabs.map(tabName => $('.product_catalog_tabs').find(`a[data-gender="${tabName}"]`));
      
      for(const tabName of possibleTabs){
        const $tab = $('.product_catalog_tabs').find(`a[data-gender="${tabName}"]`);
        const $section = $(`.catalog_product_container.${tabName}`);

        $tab.click(function(){
          if($tab.hasClass('active'))return;
          $getVisibleTab().hide();
          $section.show();
          $tabs.forEach($tab => $($tab).removeClass('active'));
          $tab.addClass('active');
          resetScrollAndButtons();
          // $getVisibleTab().fadeOut(350, function(){
          //     $section.fadeIn();
          //     $tabs.forEach($tab => $($tab).removeClass('active'));
          //     $tab.addClass('active')
          //     resetScrollAndButtons();
          // });
        })
      }
      
    }

    const initAmbassadorTracking = async () => {
      const code = _s1.getQueryParam('s1_amb');
      if(!code) return;
      _s1.addAttributeToOrder('s1_amb',code.toLowerCase()).then(res => res.json()).then(console.log);
      console.log('s1_amb:', code);
    }

    const initCloudMeshSignUp = () => {
      
      let formId = 'Vizb4j';
      if(window.location.href.includes('uk.stepone.life')){
       formId = 'Ty6HvP'
      }
      
      const isCloudMesh = window.location.href.toLowerCase().includes('cloud-mesh');
      if(isCloudMesh){
        setTimeout(function(){
           window._klOnsite.push(['openForm', formId]);
        }, 2000)
       
      }

      $(document).on('click', '#cloud-mesh-sign-up', function(){
        window._klOnsite.push(['openForm', formId]);
      })
    }

    const initLecSignUp = () => {
      $(document).on('click', '#lec-notify', function(){
           window.triggerLECPopup();
      })
    }

    // ******* Start New Pack Buttons

    window.openBundleBuilder = () => {
      const tiers = _s1.getTieredPricing();
      const $drawer = jQuery('x-drawer.bundle-builder-drawer');
      if(!!window.setPackQty) window.setPackQty(tiers.mid_tier.threshold);
      // $drawer.find('.depressed_btn[data-qty="7"]').click();
      if($drawer.length > 0) $drawer[0].show();
    }

    const setProductStrikePriceAndRing = (showNormal, price) => {

      const $price_section = $('.product-price');
      const $main_price = $price_section.find('.main-price');
      const $new_price = $price_section.find('.new-price');
      const $compare_at_price = $price_section.find('.compare-at-price');

      $(`.product_pack_button`).removeClass('active');
      const $active_btn = $(`.product_pack_button[data-price="${price.toFixed(2)}"]`);
      $active_btn.addClass('active');
      
      if(showNormal){
        // Single: show current price + compare_at_price (struck through) if it exists
        $main_price.css('text-decoration', '').css('color', '').show();
        $new_price.hide();
        // Compare-at-price should already be visible if it exists (rendered by Liquid)
        if($compare_at_price.length > 0) {
          $compare_at_price.show();
        }
      } else {
        // Pack: show original price (struck through) + pack price
        // If compare_at_price exists, use it; otherwise use main_price as the original
        if($compare_at_price.length > 0) {
          // Use compare_at_price as the original (struck through)
          $compare_at_price.show();
          $main_price.hide();
        } else {
          // No compare_at_price, so use main_price as the original (struck through)
          $main_price.css('text-decoration', 'line-through').css('color', '#767676') /* a11y 13/10/2026: #999 is 2.84:1 */.show();
        }
        $new_price.show().text(`${_s1.getTieredPricing().currency}${price.toFixed(2)} ea`);
      }

    }

    const setPackButtonsQuantity = () => {
      
      if(!window.location.href.includes('/products/')) return;

      const $btns = $('.product_pack_button');
      const quantity_selector_input = $('.product-info__quantity-selector quantity-selector input')[0];

      const current_price = meta && (meta.product.variants[0].price/100);
      if(!current_price) return;
      if(!quantity_selector_input) return;
      
      quantity_selector_input.addEventListener('quantity:change', function(e){
        if(_s1.currentProduct.tags.includes('no-tier')) return;
        const qty = Number(e.detail.value);
        const tiers = _s1.getTieredPricing();
        const lowThreshold = tiers.low_tier.threshold;
        const midThreshold = tiers.mid_tier.threshold;
        const highThreshold = tiers.high_tier.threshold;

        const $pack_savings = $('.pack-savings');
        const $pack_savings_container = $('.pack-savings-container');

        if(qty < lowThreshold){
          $pack_savings_container.hide();
        } else if ($pack_savings){
          $pack_savings_container.show();
          let diff = 0;
          if(qty >= highThreshold){
            diff = tiers.high_tier.dollars_off;
          } else if(qty >= midThreshold){
            diff = tiers.mid_tier.dollars_off;
          } else if(qty >= lowThreshold){
            diff = tiers.low_tier.dollars_off;
          }
          const savings = qty * diff
          $pack_savings.text(savings)
        }

        if(qty < lowThreshold){
          $pack_savings_container.hide();
        } else if ($pack_savings){
          $pack_savings_container.show();
          if(_s1.currentProduct && _s1.currentProduct.title.toLowerCase().includes('sock')){
            let diff = 0;
            if(qty >= midThreshold){
              diff = tiers.mid_tier.dollars_off;
            } else if(qty >= lowThreshold){
              diff = tiers.low_tier.dollars_off;
            }
            const savings = qty * diff
            $pack_savings.text(savings)
          } else {
            let diff = 0;
            if(qty >= highThreshold){
              diff = tiers.high_tier.dollars_off;
            } else if(qty >= midThreshold){
              diff = tiers.mid_tier.dollars_off;
            } else if(qty >= lowThreshold){
              diff = tiers.low_tier.dollars_off;
            }
            const savings = qty * diff
            $pack_savings.text(savings)
          }
        }

        if(qty < lowThreshold) return setProductStrikePriceAndRing(true, current_price);
        if(qty >= lowThreshold && qty < midThreshold) return setProductStrikePriceAndRing(false, current_price - tiers.low_tier.dollars_off);
        if(qty >= midThreshold && qty < highThreshold) return setProductStrikePriceAndRing(false, current_price - tiers.mid_tier.dollars_off);
        if(_s1.currentProduct && _s1.currentProduct.title.toLowerCase().includes('sock')) return;
        return setProductStrikePriceAndRing(false, current_price - tiers.high_tier.dollars_off);
      })
      
      $btns.click(function(){
        
        const $btn = $(this);
        const qty = $(this).data('qty');

        gtag('event', 'pack_quick_add', {
            'product_handle': new URL(window.location.href).pathname.split('/products')[1],
            'pack_option': qty
         })
        
        quantity_selector_input.quantity = Number(qty);
      })

      // FOR EXPERIMENT:
      if(window.location.href.includes('gift-card')) return;
      const pack_qty = new URL(window.location.href).searchParams.get('pack-qty');
      if(pack_qty && Number.isFinite(Number(pack_qty))) return quantity_selector_input.quantity = Number(pack_qty);
      if(window.location.href.includes("precious-metals") || window.location.href.includes("better-beer")) return quantity_selector_input.quantity = 1;
      quantity_selector_input.quantity = Number(7);
      
    }

    setPackButtonsQuantity();

    // ******** End New Pack Buttons

    const initSideCartSignUp = () => {
      
      const showIfUnidentified = async () => {
        const isKnown = await klaviyo.isIdentified();
        if(isKnown) return;
        
        _s1.queue(function(){
          return $('.side-cart-signup').length > 0
        }, function(){
           $('.side-cart-signup').css('display', 'flex');
          return true;
        })
      }

      _s1.addCartListener(function(){
        showIfUnidentified();
      })

      showIfUnidentified();

      const klaviyo_id = 'WrJG2x'
      
      $(document).on('click', '.side-cart-signup__btn', function(){
        $('cart-drawer')[0].hide();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', klaviyo_id]);
      })
      
    }

    const initBannerAnalytics = () => {

      const $slider = $('slideshow-carousel');
      
      const bannerImpression = (slide, index) => {
        const url = $(slide).find('img')[0].src.split('?')[0];
        gtag('event', 'carousel_impression', {
          'image_identifier': url,
          'image_position': index + 1,
          'timestamp': Date.now()
        })
      }

      const bannerClick = (btn) => {
        const url = $($slider[0].selectedSlide).find('img')[0].src.split('?')[0];
        gtag('event', 'carousel_button_click', {
          'image_identifier': url,
          'carousel_button_url': btn.href.split('https://stepone.life')[1] || '',
          'carousel_button_text': btn.innerText,
          'timestamp': Date.now()
        })
      }
      
      document.addEventListener('carousel:select', function(e){
        bannerImpression(e.detail.slide, e.detail.index);
      })

      if($slider.length > 0){
        bannerImpression($slider[0].selectedSlide, 0);
      }

      $(document).on('click', 'slideshow-carousel .button', function(e){
        bannerClick(this);
      })
      
    }

    const showProductRangeSlide = () => {
      const $slideshow = $('slideshow-carousel');
      const hasSlideshow = $slideshow.length > 0;
      if(!hasSlideshow) return;
      
      const slides = $slideshow[0].items;
      const slideGroupings = slides.reduce((obj,slide) => {
        const type = $(slide).data('type');
        if(!type) return obj;
        obj[type] = obj[type] || [];
        obj[type].push(slide);
        return obj;
      }, {mens: [], womens: [], mixed: [], kids: [], new: []})

      const updateSliderFromSlide = (slide) => {
        const index = $slideshow[0].items.indexOf(slide);
        if(index < 0) return;
        $slideshow[0].select(index);
      }

      const url = window.location.href.toLowerCase();
      
      if(url.includes('women')){
        if(slideGroupings.womens.length > 0) return updateSliderFromSlide(slideGroupings.womens[0]);
        if(slideGroupings.mixed.length > 0) return updateSliderFromSlide(slideGroupings.mixed[0]);
      }

      if(url.includes('mixed')){
        if(slideGroupings.mixed.length > 0) return updateSliderFromSlide(slideGroupings.mixed[0]);        
      }

      if(url.includes('kids') || url.includes('juniors')){
        if(slideGroupings.mixed.length > 0) return updateSliderFromSlide(slideGroupings.kids[0]);        
      }

      if(url.includes('tofu') || url.includes('mofu')){
        if(slideGroupings.mixed.length > 0) return updateSliderFromSlide(slideGroupings.new[0]);        
      }
      
    }

    const addToCartLink = async () => {
      const atc = new URL(window.location.href).searchParams.get('add_to_cart')
      if(!atc) return;
      
      const items =  atc.split(',').map(p => {
        const [id,quantity] = p.split(':');
        return {id: Number(id), quantity: Number(quantity)};
      })

      for(let i=0;i<items.length;i++){
        const item = items[i];
        if(i === items.length - 1){
          await _s1.addToCartAndRefreshCart([item]);
        } else {
          await _s1.addToCart([item]);
        }
      }
      // for(const item of items){
      //   _s1.addToCartAndRefreshCart([item]);
      // }
      // _s1.addToCartAndRefreshCart(items);
    }

    const initSteptember = () => {
    	if(!window.location.href.includes('steptember')) return;
    	if(window.location.href.includes('products')) return;
    	const partner = window.location.href.split('/steptember')[1].replace('-', '');
    	_s1.addAttributeToOrder('steptember',partner)
    }

    const triggerBundleBuilder = () => {
      const url = new URL(window.location.href);
      if(url.searchParams.get('bundle_builder')){
        ui && ui.openModal() || null;
      }
    }

    const initPeriodProduct = () => {
      if(!window.location.href.toLowerCase().includes('period'))return;
      $(document).on('click', '.is-size-light', function(e){
        const isDisabled = $('.is-size-light').attr('disabled');
        if(isDisabled) return;
        $('#period-tampons').text('2-3 tampons');
      })
      $(document).on('click', '.is-size-moderate', function(e){
        const isDisabled = $('.is-size-moderate').attr('disabled');
        if(isDisabled) return;
        $('#period-tampons').text('2-3 tampons');
      })
      $(document).on('click', '.is-size-heavy', function(e){
        const isDisabled = $('.is-size-heavy').attr('disabled');
        if(isDisabled) return;
        $('#period-tampons').text('3-4 tampons');
      })
    }

    const openSizeGuide = () => {
      const params = new URL(window.location.href).searchParams
      const size_guide = params.get('size_guide');
      const fit_btn = document.querySelector('.find-my-fit')
      console.log(size_guide,fit_btn)
      if(window.location.href.includes('/products/') && size_guide && fit_btn){
          fit_btn.click();
      }
    }

    const initBlackFriday25Offer = () => {
      const url = new URL(window.location.href);
      const params = url.searchParams.get('discount');
      console.log('BFCM params', params);
      _s1.getCart().then(function(cart){
        if(cart.attributes['bfcm25-mystery'] || cart.attributes['bfcm25-tee']) return;
        if(!params) return;
        if(params.toUpperCase() == 'BFCMMYSTERY'){
          console.log('BFCM',1)
          _s1.addAttributeToOrder('bfcm25-mystery', 'true');
        }
        if(params.toUpperCase() == 'BFCMTSHIRT'){
          console.log('BFCM',2)
          _s1.addAttributeToOrder('bfcm25-tee', 'true');
          window.location.reload();
        }
      })
    }

    _s1.hardRefreshCart = async () => {
    const html = await (await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)).text();
    const current = document.querySelector('cart-drawer');
    const cartDOM = new DOMParser().parseFromString(html, "text/html");
    current.replaceChildren(...cartDOM.querySelector('#cart-drawer').children);
     window.initDiscountBar();
  }

    _s1.cartExperiment = {
      key: 'experiment',
      async startExperiment(experiment = false){
        console.log('starting experiment...');
        const cart = await _s1.getCart();
        console.log('setting key from fetch...');
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                experiment: experiment
              }
            })
          });
        const token = cart.token;
        const attributes = cart.attributes;
        //@todo - hard coded C value to refresh anyone with previous B
        if(attributes[this.key] == 'C'){
           console.log('has key already...');
           window.s1DiscountBar.refresh();
        } else {
           console.log('setting key from api...');
         await this.startNewSession(token, experiment);
        }
      },
      async startNewSession(token, experiment){
         console.log('calling api...');
          const region = _s1.getS1Region();
          let url;
          if(region == 'au') url = 'https://australia-southeast1-stepone-backend.cloudfunctions.net/setExperimentOnCart';
          if(region == 'uk') url = 'https://europe-central2-stepone-backend-uk.cloudfunctions.net/setExperimentOnCart';
          if(region == 'us') url = '';
          console.log('setting experiment attribute...');
          const response = await fetch(`${url}?cart_token=${token}${ experiment ? `&experiment=${experiment}` : ''}`, {
              method: "GET",
              mode: "cors",
              headers: {
                "Content-Type": "application/json",
              }
          })
          await _s1.hardRefreshCart();
          window.s1DiscountBar.refresh();
          return await _s1.getCart();
      }
    }

    //addToCartLink();
    // _s1.cartExperiment.startExperiment('D').then(console.log('experiment deployed: D'));
    initSteptember();
    showProductRangeSlide();
    initSideCartSignUp();
    addAttributeForRefferingFriend();
    showGenderProductTab();
    initFatherAndSon();
    //initScrollFromBanner();
    //initProductCardsSwatches();
    initSurfPages();
    initSurfDonationBanner(); 
    initDiscountBarV3();
    initProductCardSwatchesV2();
    initProductCardSwitcher();
    initAmbassadorTracking();
    initLecSignUp();
    //initCloudMeshSignUp();
    initBannerAnalytics();
    triggerBundleBuilder();
    initPeriodProduct();
    openSizeGuide();
    initBlackFriday25Offer();
    
  })
  
  
})()